import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { Text } from "../../Text/Text.mjs";
import { Dialog } from "../../Dialog/Dialog.mjs";
import { Button } from "../../Button/Button.mjs";
import { IllustrationWarning } from "../../illustrations/IllustrationWarning/IllustrationWarning.mjs";
const WarningModal = ({
  visible,
  closeModal,
  onSubmit,
  title,
  description,
  closeButtonLabel,
  confirmButtonLabel,
  id
}) => {
  const onExit = () => {
    onSubmit();
    closeModal();
  };
  const closeButtonId = `${id}-cancel`;
  const confirmButtonId = `${id}-yes`;
  return /* @__PURE__ */ jsx(Dialog, { id, open: visible, onClose: closeModal, width: "xsmall", children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: [
    /* @__PURE__ */ jsx(IllustrationWarning, {}),
    /* @__PURE__ */ jsx(Box, { paddingTop: "gutter", paddingBottom: "medium", children: /* @__PURE__ */ jsx(Text, { size: "large", weight: "strong", children: title }) }),
    /* @__PURE__ */ jsx(Box, { paddingBottom: "large", children: /* @__PURE__ */ jsx(Text, { size: "medium", weight: "regular", align: "center", children: description }) }),
    /* @__PURE__ */ jsxs(Box, { display: "flex", width: "full", children: [
      closeButtonLabel && /* @__PURE__ */ jsx(Button, { variant: "transparent", onClick: closeModal, id: closeButtonId, children: closeButtonLabel }),
      /* @__PURE__ */ jsx(Button, { variant: "solid", onClick: onExit, id: confirmButtonId, children: confirmButtonLabel })
    ] })
  ] }) });
};
export {
  WarningModal
};
